import { stringify } from "query-string"
import { dhFoods } from "./api"

const endpoint = "/order"

export const sendOrder = async data => {
  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const getOrder = async (orderId) => {
  const response = await dhFoods.get(`${endpoint}/${orderId}`)

  return response.data
}

export const getUserOrders = async queries => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/all?${query}`)

  return response.data
}

export const getOrders = async queries => {
  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}